import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { OwlCarousel } from 'ngx-owl-carousel';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit {

  @Input() Images!: any[];
  @ViewChild('owlElement') owlElement!: OwlCarousel
  constructor() { 
    
  }

  ngOnInit(): void {
  }
  fun() {
    this.owlElement.next([200])
    //duration 200ms
  }

}
